import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PicturesRunnerResponse } from '../interfaces/picturesRunnerResponse.interface';

@Injectable({
  providedIn: 'root'
})
export class PicturesService {

  constructor(private readonly http: HttpClient) { }

  getPicturesRunner(eventId: string, bib: number): Observable<PicturesRunnerResponse> {
    return this.http.get<PicturesRunnerResponse>(`${environment.apiUrl}/picture/event/${eventId}/runner/${bib}`);
  }

  downloadPicture(pictureId: string, runnerName: string, raceName: string): void {
    this.http.get(`${environment.apiUrl}/picture/${pictureId}`, { responseType: 'blob' }).subscribe(res => {
      const url = window.URL.createObjectURL(res);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${_.replace(raceName, ' ', '_')}_${_.replace(runnerName, ' ', '_')}.jpg`;
      a.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
      window.URL.revokeObjectURL(url);
      a.remove();
    })
  }
}
